import React from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import PropTypes from 'prop-types'
import DataTableDemo from '../../generals/datatables/datatable'

export default function ModalRSStatusHistory ({ title, show, onHide, btnError }) {
  return (
          <Modal
              show={show}
              size="lg"
              onHide={onHide}
              aria-labelledby="contained-modal-title-vcenter"
              centered
          >
              <Modal.Header closeButton>
                  <Modal.Title id="contained-modal-title-vcenter">
                      {title}
                  </Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ padding: '1.5rem' }}>
                <DataTableDemo
                    // data={}
                    table="statusHistoryRS"
                    editUsers={false}
                    rowStates={false}
                    rowSelecteds={false}
                    searchs={['state', 'information', 'date', 'user']}
                    columns={[
                      {
                        field: 'state',
                        header: 'Estado'
                      },
                      {
                        field: 'information',
                        header: 'Información'
                      },
                      {
                        field: 'date',
                        header: 'Fecha'
                      },
                      {
                        field: 'user',
                        header: 'Usuario'
                      }
                    ]}
                />
              </Modal.Body>
              <Modal.Footer>
                  <Button onClick={onHide} variant="danger">
                      {btnError}
                  </Button>
              </Modal.Footer>
          </Modal>
  )
}

ModalRSStatusHistory.propTypes = {
  onHide: PropTypes.func,
  show: PropTypes.bool,
  title: PropTypes.string,
  btnError: PropTypes.string
}
